<template>
      <v-row>
        <v-col cols="4" offset="4">
            <v-form v-on:submit.prevent="login" class="mt-12">
              <v-card class="elevation-12">
                <v-toolbar dark>
                  <v-toolbar-title>
                    <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.3 35.4">
                      <path
                        d="M25.9,35.1l-2.6-1c0,0-0.4-7.4-6.7-9.4c5.9-2,6.6-8.8,6.6-8.8l0.8-0.2v-0.5h-3.6 c0,0-1,3.8-5.4,4.6c0.8-0.6,1.4-1.6,1.4-2.7c0-1.8-1.4-3.2-3.2-3.2c-1.8,0-3.2,1.4-3.2,3.2c0,1.1,0.5,2.1,1.4,2.6 c-4.3-0.9-5.3-4.6-5.3-4.6H2.3v0.5l0.8,0.2c0,0,0.6,6.9,6.5,8.8c-6.3,2-6.8,9.4-6.8,9.4l-2.5,0.9l-0.2,0.2h5.7 c0,0,1.3-4.9,7.2-4.9c6,0,7.2,4.9,7.2,4.9H26L25.9,35.1z"/>
                      <path
                        d="M6.3,10c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6C5.6,8.4,6.3,9.1,6.3,10z M6.5,4.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6C7.3,7.9,8,7.2,8,6.3C8,5.5,7.3,4.8,6.5,4.8z M9.3,1.5 C8.4,1.5,7.7,2.1,7.7,3c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C10.8,2.1,10.1,1.5,9.3,1.5z M13.6,0.2 c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C15.2,0.9,14.5,0.2,13.6,0.2z M17.9,2.4 c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C19.5,3.1,18.8,2.4,17.9,2.4z M20.8,7 c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C22.4,7.7,21.7,7,20.8,7z"/>
                    </svg>
                    RU - Tourenplaner
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-alert :value="error" type="error" outlined>
                    Die Kombination aus Benutzername und Passwort ist falsch.
                  </v-alert>
                  <v-text-field required prepend-icon="person" v-model="username"
                                label="Benutzername" type="text"></v-text-field>
                  <v-text-field required prepend-icon="lock" v-model="password" label="Passwort"
                                type="password"></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn type="submit" color="primary">Login</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
        </v-col>
      </v-row>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      error: false
    }
  },
  methods: {
    login () {
      const {username, password} = this
      this.$store.dispatch('AUTH_REQUEST', {username, password}).then(() => {
        this.$store.dispatch('getAllCities') // dispatch loading
        this.$store.dispatch('getAllDistricts') // dispatch loading
        this.$store.dispatch('getAllStreets') // dispatch loading
        this.$store.dispatch('getAllTour') // dispatch loading
        this.$store.dispatch('getAllTourTemplates') // dispatch loading
        this.$store.dispatch('getAllDevices') // dispatch loading
        this.$store.dispatch('getAllDuties') // dispatch loading
        this.$store.dispatch('USER_REQUEST')
        this.$router.push({name: 'dashboard'}).catch(() => {})
      }, () => {
        this.error = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .icon {
    height: 2rem;
    fill: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue